/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {SOCIAL_AUTH_STRATEGIES as ɵa} from './lib/strategy/social-auth-strategies.token';
export {SocialAuthStrategy as ɵb} from './lib/strategy/social-auth-strategy';